export const CARGO_LEADS_RESET_STATE = 'CARGO_LEADS_RESET_STATE';
export const CARGO_LEADS_CURRENT_ITEM = 'CARGO_LEADS_CURRENT_ITEM';

export const CARGO_LEADS_REQUEST_LOADING = 'CARGO_LEADS_REQUEST_LOADING';
export const CARGO_LEADS_REQUEST_SUCCESS = 'CARGO_LEADS_REQUEST_SUCCESS';
export const CARGO_LEADS_REQUEST_FAILED = 'CARGO_LEADS_REQUEST_FAILED';

export const CARGO_LEADS_CURRENT_ACTION = 'CARGO_LEADS_CURRENT_ACTION';
export const CARGO_LEADS_RESET_ACTION = 'CARGO_LEADS_RESET_ACTION';